import React, { useState } from 'react';
import s from '../../styles/corporate/Corporate.module.css';
import { VALUES, WORKSPACES } from './data';
import Shot from './Shot';

const no = (i) => `0${i + 1}`;

/** 인재·문화 — 가치 목록을 고르면 사진 위 배지가 바뀐다 */
const CorpPeople = () => {
  const [active, setActive] = useState(0);
  const cur = VALUES[active];

  return (
    <section className={`${s.section} ${s.sectionLine}`} id="people">
      <div className={s.wrap}>
        <h2 className={`${s.h2} ${s.reveal}`}>
          당신의 성장이
          <br />
          오퍼그룹의 미래가 됩니다.
        </h2>

        <div className={s.peopleGrid}>
          <div className={`${s.peoplePhoto} ${s.reveal} ${s.revealScale}`}>
            {/* 네 장을 겹쳐 두고 고른 가치의 사진만 보여준다 (교체 시 깜빡임이 없다) */}
            {VALUES.map((value, i) => (
              <div
                key={value.key}
                className={`${s.peopleLayer} ${i === active ? s.peopleLayerOn : ''}`}
                aria-hidden={i === active ? undefined : 'true'}
              >
                <Shot
                  file={value.file}
                  alt={value.title}
                  placeholder="구성원 사진"
                  eager={i === 0}
                />
              </div>
            ))}
            <div className={s.peopleBadge}>
              <span className={s.peopleBadgeNum} translate="no">
                {no(active)}
              </span>
              <span className={s.peopleBadgeBar} aria-hidden="true" />
              <span className={s.peopleBadgeText}>
                <span className={s.peopleBadgeKey} translate="no">
                  {cur.key}
                </span>
                <span className={s.peopleBadgeTitle}>{cur.title}</span>
              </span>
            </div>
          </div>

          <div className={s.valueList}>
            <p className={`${s.lead} ${s.reveal}`} style={{ marginBottom: 32, maxWidth: 460 }}>
              개인의 가능성을 존중하고, 성장의 기회를 넓히며, 성과의 가치를 함께 나누는 기업문화를
              지향합니다.
            </p>

            {VALUES.map((value, i) => (
              <button
                type="button"
                key={value.key}
                className={`${s.value} ${i === active ? s.valueOn : ''}`}
                onMouseEnter={() => setActive(i)}
                onFocus={() => setActive(i)}
                onClick={() => setActive(i)}
                aria-expanded={i === active}
              >
                <span className={s.valueMark} aria-hidden="true" />
                <span className={s.valueRow}>
                  <span className={s.valueNo} translate="no">
                    {no(i)}
                  </span>
                  <span className={s.valueTitle}>{value.title}</span>
                  <span className={s.valueKey} translate="no">
                    {value.key}
                  </span>
                </span>
                <span className={`${s.collapse} ${i === active ? s.collapseOpen : ''}`}>
                  <span>
                    <p className={s.valueBody}>{value.body}</p>
                  </span>
                </span>
              </button>
            ))}
          </div>
        </div>

        <div className={s.workHead}>
          <h3 className={`${s.workTitle} ${s.reveal}`}>사람과 아이디어가 머무는 공간</h3>
          <p className={`${s.lead} ${s.reveal}`} data-delay="100" style={{ maxWidth: 420 }}>
            쾌적한 업무공간과 협업·재충전을 위한 환경을 통해
            <br />
            구성원이 역량을 발휘할 수 있도록 합니다.
          </p>
        </div>

        <div className={s.workGrid}>
          {WORKSPACES.map((item, i) => (
            <div className={`${s.workItem} ${s.reveal}`} data-delay={i * 100} key={item.eyebrow}>
              <div className={s.workShot}>
                <Shot file={item.file} alt={item.label} placeholder={item.placeholder} />
              </div>
              <div className={s.workCaption}>
                <span>{item.label}</span>
                <span className={s.workEyebrow} translate="no">
                  {item.eyebrow}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CorpPeople;
